import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import { Alert } from '@deerplusofficial/pos-components';
import { withClient } from '@deerplusofficial/pos-hoc';
import { mapState } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import { withQueryPointOfSales, withQueryUser } from '../../model/Queries';
import { userShape } from '../../model/Types';
import { Dimmer } from '../../components';
import SidebarContent from './SidebarContent';
import Slogan from './Slogan';
import Profile from './Profile';
import PosButton from './PosButton';

class PosList extends PureComponent {
  static propTypes = {
    user: userShape,
    channel: PropTypes.shape(),
    pointOfSales: PropTypes.arrayOf(PropTypes.shape()),
    client: PropTypes.shape(),
  };

  static defaultProps = {
    user: {},
    pointOfSales: null,
  };

  get isLoading() {
    const { user, pointOfSales } = this.props;
    return !_.size(user) || _.isNil(pointOfSales);
  }

  onPointOfSalesRefetch = () => this.props.onPointOfSalesRefetch();

  onPointOfSalesNotFound = () => {
    const {
      client: { onLogout },
    } = this.props;

    Alert.fire({
      titleText: 'POS尚未設定，因此無法使用。請到"通路管理"新增POS機',
      type: 'error',
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
      preConfirm: onLogout,
    });
  };

  renderPosList = () => {
    const { user, pointOfSales, channel } = this.props;
    const { name: companyName, logo: companyPhotoUrl } = channel;

    if (_.size(pointOfSales) === 0) return this.onPointOfSalesNotFound();

    return (
      <React.Fragment>
        <Slogan>
          {`Hi, ${user.first_name} ${user.last_name}`}
          <br />
          請選擇您今天要登入的POS機
        </Slogan>
        <Profile companyName={companyName} companyPhotoUrl={companyPhotoUrl} />
        {_.map(pointOfSales, this.renderPosButton)}
      </React.Fragment>
    );
  };

  renderPosButton = pos => (
    <PosButton key={pos.id} onRefetch={this.onPointOfSalesRefetch} {...pos} />
  );

  render() {
    return (
      <SidebarContent>
        {this.isLoading ? <Dimmer /> : this.renderPosList()}
      </SidebarContent>
    );
  }
}

export default fp.compose(
  withClient(),
  withQueryUser(),
  withQueryPointOfSales(),
  connect(mapState(['user', 'channel']))
)(PosList);



// WEBPACK FOOTER //
// ./src/pages/Login/PosList.js